import { reject } from "lodash";
import { useInjection } from "@linkfluence/core/di";
import { UserRepositoryUID } from "@linkfluence/core/user/repositories/UserRepo";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UserRepository } from "@radarly/core/user/repositories/UserRepository";
import { useCurrentUser } from "./useCurrentUser";

export function useCloseUserBanner() {
  const repository = useInjection<UserRepository>(UserRepositoryUID);
  const queryClient = useQueryClient();
  const currentUser = useCurrentUser();
  const onMutate = (bannerId: number) => {
    queryClient.setQueryData(["/user/current"], {
      ...currentUser,
      banners: reject(currentUser.banners, { id: bannerId }),
    });
  };
  const onError = () => {
    queryClient.setQueryData(["/user/current"], currentUser);
  };
  const { mutate, isLoading, isSuccess, isError } = useMutation(
    (bannerId: number) => {
      return repository.closeUserBanner(bannerId);
    },
    {
      onMutate,
      onError,
    }
  );
  return {
    closeUserBanner: (bannerId: number) => mutate(bannerId),
    isLoading,
    isSuccess,
    isError,
  };
}
